import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.darkNight,
  paraColor: colors.darkNight,
  subHeadingColor: colors.clearBlue,
  bgColor: colors.sandy,
  ctaColor: colors.orangish,
  cardRadius: '20px',
  textColorDark: colors.darkNight,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;